// Auto-generated by jvf_viewer/scripts/build-variant-map.ts
// Do not edit manually — run the script to regenerate.
//
// Maps ObjectSymbology codeBase → attribute name + value→variant index.
// At render time, jvfLayers.ts reads zaznam.attributes[attrName], coerces
// it to string, looks up valueToVariantIndex, and picks SYMBOLOGY[code].variants[idx].

export interface VariantAttrMapEntry {
  attrName: string;
  /** String representation of attribute value → index into SYMBOLOGY[code].variants */
  valueToVariantIndex: Record<string, number>;
}

export const VARIANT_ATTR: Record<string, VariantAttrMapEntry> = {
  '0100000004': {
    attrName: 'KategoriePozemniKomunikace',
    valueToVariantIndex: {
      '2': 0,
      '3': 1,
      '4': 2,
      '5': 3,
      '6': 4,
      '7': 5,
      '8': 6,
      '9': 7,
      '11': 9,
      '99': 10,
    },
  },
  '0100000020': {
    attrName: 'KategorieZeleznicniTrate',
    valueToVariantIndex: {
      '2': 0,
      '3': 1,
      '4': 2,
      '5': 3,
      '98': 4,
      '99': 5,
    },
  },
  '0100000092': {
    attrName: 'TypTechnickehoKanalu',
    valueToVariantIndex: {
      '4': 0,
      '5': 1,
      '6': 2,
      '7': 3,
      '98': 4,
      '99': 5,
    },
  },
  '0100000095': {
    attrName: 'TypPodpernehoZarizeni',
    valueToVariantIndex: {
      '1': 0,
      '4': 4,
      '5': 6,
      '6': 7,
      '7': 8,
      '8': 9,
      '9': 1,
      '10': 2,
      '11': 3,
      '12': 5,
    },
  },
  '0100000098': {
    attrName: 'MaximalniNapetovaHladina',
    valueToVariantIndex: {
      '1': 0,
      '2': 1,
      '3': 2,
      '4': 3,
      '99': 4,
    },
  },
  '0100000101': {
    attrName: 'TypZarizeniElektrickeSite',
    valueToVariantIndex: {
      '1': 0,
      '98': 1,
    },
  },
  '0100000103': {
    attrName: 'MaximalniNapetovaHladina',
    valueToVariantIndex: {
      '1': 0,
      '2': 1,
      '3': 2,
      '4': 3,
      '99': 4,
    },
  },
  '0100000107': {
    attrName: 'TypZarizeniSiteEK',
    valueToVariantIndex: {
      '2': 0,
      '3': 1,
    },
  },
  '0100000109': {
    attrName: 'TlakovaHladinaPlynovodniSite',
    valueToVariantIndex: {
      '1': 0,
      '2': 1,
      '3': 2,
      '4': 3,
      '99': 4,
    },
  },
  '0100000111': {
    attrName: 'TypZarizeniPlynovodniSite',
    valueToVariantIndex: {
      '1': 0,
      '2': 1,
      '4': 2,
      '98': 3,
    },
  },
  '0100000112': {
    attrName: 'TlakovaHladinaPlynovodniSite',
    valueToVariantIndex: {
      '1': 0,
      '2': 1,
      '3': 2,
      '4': 3,
      '99': 4,
    },
  },
  '0100000116': {
    attrName: 'TypZarizeniVodovodniPripojky',
    valueToVariantIndex: {
      '2': 0,
      '98': 1,
    },
  },
  '0100000119': {
    attrName: 'TypZarizeniPrivadece',
    valueToVariantIndex: {
      '98': 0,
      '99': 1,
    },
  },
  '0100000124': {
    attrName: 'TypZarizeniKanalizacniPripojky',
    valueToVariantIndex: {
      '1': 0,
      '2': 1,
      '3': 2,
      '4': 3,
      '98': 4,
    },
  },
  '0100000128': {
    attrName: 'TypZarizeniSiteProduktovodu',
    valueToVariantIndex: {
      '1': 0,
      '99': 1,
    },
  },
  '0100000131': {
    attrName: 'TypZarizeniTeplovodniSite',
    valueToVariantIndex: {
      '1': 0,
      '2': 1,
      '98': 2,
    },
  },
  '0100000134': {
    attrName: 'TypZarizeniPotrubniPosty',
    valueToVariantIndex: {
      '1': 0,
      '98': 1,
    },
  },
  '0100000135': {
    attrName: 'TypPovrchovehoZnakuTI',
    valueToVariantIndex: {
      '1': 0,
      '2': 1,
      '3': 2,
      '4': 3,
      '5': 4,
      '6': 5,
      '7': 6,
      '8': 7,
      '9': 8,
      '98': 9,
    },
  },
  '0100000159': {
    attrName: 'TypDrobneKulturniStavby',
    valueToVariantIndex: {
      '1': 0,
      '2': 1,
      '3': 2,
      '4': 3,
      '5': 4,
      '6': 5,
      '99': 6,
    },
  },
  '0100000168': {
    attrName: 'TypZdi',
    valueToVariantIndex: {
      '1': 1,
      '2': 2,
      '3': 3,
      '4': 0,
      '99': 4,
    },
  },
  '0100000201': {
    attrName: 'TypNosiceTechnickehoZarizeni',
    valueToVariantIndex: {
      '1': 1,
      '2': 2,
      '3': 0,
      '4': 3,
      '6': 5,
      '98': 6,
      '99': 7,
    },
  },
  '0100000207': {
    attrName: 'TypZemedelskePlochy',
    valueToVariantIndex: {
      '1': 0,
      '2': 1,
      '3': 2,
      '4': 3,
      '5': 4,
    },
  },
  '0100000215': {
    attrName: 'TypUdrzovaneZelene',
    valueToVariantIndex: {
      '1': 0,
      '2': 1,
      '3': 2,
      '99': 3,
    },
  },
  '0100000294': {
    attrName: 'TypOPPozemniKomunikace',
    valueToVariantIndex: {
      '1': 0,
      '3': 1,
      '4': 2,
      '5': 3,
      '6': 4,
      '7': 5,
    },
  },
  '0100000296': {
    attrName: 'TypOPLetiste',
    valueToVariantIndex: {
      '1': 0,
      '2': 1,
      '3': 2,
      '4': 3,
      '6': 5,
    },
  },
  '0100000336': {
    attrName: 'TypObjektuVodovodniSite',
    valueToVariantIndex: {
      '1': 0,
      '2': 1,
      '3': 2,
      '4': 3,
      '5': 4,
      '6': 5,
      '98': 6,
    },
  },
  '0100000337': {
    attrName: 'TypObjektuStokoveSite',
    valueToVariantIndex: {
      '1': 0,
      '2': 1,
      '3': 2,
      '4': 3,
      '5': 4,
      '6': 5,
      '7': 6,
      '8': 7,
      '9': 8,
      '98': 9,
    },
  },
  '0100000350': {
    attrName: 'MaximalniNapetovaHladina',
    valueToVariantIndex: {
      '1': 0,
      '2': 1,
      '3': 2,
      '4': 3,
      '99': 4,
    },
  },
  '0100000354': {
    attrName: 'TlakovaHladinaPlynovodniSite',
    valueToVariantIndex: {
      '1': 0,
      '2': 1,
      '3': 2,
      '4': 3,
      '99': 4,
    },
  },
  '0100000355': {
    attrName: 'TypObjektuPlynovodniSiteZameru',
    valueToVariantIndex: {
      '98': 4,
      '99': 5,
    },
  },
  '0100000359': {
    attrName: 'TypObjektuStokoveSiteZameru',
    valueToVariantIndex: {
      '1': 0,
      '98': 1,
      '99': 2,
    },
  },
  '100000113': {
    attrName: 'TypTrasyVodovodniSite',
    valueToVariantIndex: {
      '1': 0,
      '2': 1,
      '98': 2,
      '99': 3,
    },
  },
  '100000121': {
    attrName: 'TypTrasyStokoveSite',
    valueToVariantIndex: {
      '1': 0,
      '4': 6,
      '98': 12,
      '99': 18,
    },
  },
  '100000130': {
    attrName: 'TypTrasyTeplovodniSite',
    valueToVariantIndex: {
      '1': 0,
      '2': 4,
      '99': 8,
    },
  },
  '100000137': {
    attrName: 'TypInzenyrskeSitePKO',
    valueToVariantIndex: {
      '1': 0,
      '2': 1,
      '3': 2,
      '4': 3,
      '5': 4,
      '6': 5,
      '7': 6,
      '99': 7,
    },
  },
  '100000138': {
    attrName: 'TypInzenyrskeSitePKO',
    valueToVariantIndex: {
      '1': 0,
      '2': 1,
      '3': 2,
      '4': 3,
      '5': 4,
      '6': 5,
      '7': 6,
      '99': 7,
    },
  },
  '100000139': {
    attrName: 'TypJinehoZarizeniStavebTI',
    valueToVariantIndex: {
      '1': 0,
      '2': 1,
      '3': 2,
    },
  },
};
